/* src/app/components/manage-access-modal/manage-access-modal.component.scss */
.modal-header {
  padding-bottom: 0.9375rem;
}
.modal-header-content {
  display: flex;
  align-items: center;
}
.modal-header-content .icon {
  width: 4rem;
  height: 4rem;
}
.modal-header-content .name,
.modal-header-content .email {
  margin-left: 1rem;
}
.modal-header-content .close {
  background-color: #ffffff;
  outline: none;
  box-shadow: none;
}
.modal-header-content .close img {
  height: 1rem;
  width: 1rem;
}
.modal-body .subtitle {
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin-bottom: 2.5rem;
}
.modal-body .scroll {
  overflow-y: auto;
  max-height: 14rem;
}
.modal-body .scroll .row-dimension {
  height: 3.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
}
.modal-body .scroll .row-dimension .ws-content {
  display: flex;
  align-items: center;
}
.modal-body .scroll .row-dimension .ws-content .ws-icon {
  width: 2rem;
  height: 2rem;
}
.modal-body .scroll .row-dimension .ws-content .ws-name {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: #72727f;
  margin-bottom: 0.1875rem;
  margin-left: 1rem;
}
.modal-body .scroll .row-dimension .ws-content .ws-projects {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: rgba(114, 114, 127, 0.64);
  margin-bottom: 0;
  margin-left: 1rem;
}
.modal-body .scroll .row-dimension .remove {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  text-align: right;
  cursor: pointer;
}
/*# sourceMappingURL=manage-access-modal.component.css.map */
